/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
// import "./index.css";

// Redux Imports
import { useSelector } from "react-redux";

import Validation from "../../../../utils/validation";
import AccountName from "../../../_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../_utils/AccountCreationComponents/ContactDetails";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CommonLayout from "../../../_utils/CommonLayout";
import LinkEntityCard from "../../../_utils/LinkEntityCard";

const FieldForceContactDetails = (props) => {
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [emailValidation, setEmailValidation] = useState(false);
  const [labelpopup, setLabelpopup] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const categories = props.categories;
  const [labels, setLabels] = useState([]);

  const handleAutofill = () => {
    props?.setPayload((prev) => ({
      ...prev,
      amount: 10000,
    }));
  };

  const handleRadioBtnAmount = (event) => {
    props?.setSelectedValueAmount(event.target.value);
    if (event.target.value === "customAmount") {
    } else if (event.target.value === "defaultAmount") {
      handleAutofill();
    }
  };

  const handleRadioBtn = (event) => {
    props?.setSelectedValue(event.target.value);
    if (event.target.value === "legalname") {
      handleUpdateLegalName();
    } else if (event.target.value === "username") {
      handleUpdateUsername();
    }
  };

  const handleDivBtnAmount = (value) => {
    props?.setSelectedValueAmount(value);
    if (value === "customAmount") {
    } else if (value === "defaultAmount") {
      handleAutofill();
    }
  };

  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      props?.setPayload((prev) => ({
        ...prev,
        amount: "",
      }));
      props?.setShowRupeeSymbol(false);
      return;
    }

    if (trimmedValue[GlobalConfiguration.lengthCheckZero] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      if (Number(numericValue) === GlobalConfiguration.defaultAmount) {
        props?.setSelectedValueAmount("defaultAmount");
      } else {
        props?.setSelectedValueAmount("customAmount");
      }
      props?.setPayload((prev) => ({
        ...prev,
        amount: numericValue,
      }));

      props?.setShowRupeeSymbol(numericValue.trim() !== "");
    }
  };

  const { verifyPAN } = useSelector((state) => state.verify);

  const allCategoryIds = useMemo(() => {
    return categories.map((category) => category.id);
  }, []);
  const isAllSelected = useMemo(() => {
    return props?.selectedCatFields.length === allCategoryIds.length;
  }, [props?.selectedCatFields, allCategoryIds]);

  const handleUpdateLegalName = () => {
    const beneficiaryData = capitalizeWords(verifyPAN?.pan_details?.full_name);
    props?.setPayload((prevPayload) => ({
      ...prevPayload,
      account_name: beneficiaryData,
    }));
    props?.setAccountNameValidation(true);
  };

  const handleUpdateUsername = () => {
    props.setPayload((prev) => ({
      ...prev,
      account_name: capitalizeWords(props.payload.userName),
    }));
  };

  const handleCategorySelect = (selectedCategories) => {
    let selectedCategoryNames = [];

    if (selectedCategories.length > GlobalConfiguration.lengthCheckZero) {
      selectedCategoryNames = selectedCategories
        .map((categoryId) => {
          const category = categories.find(
            (category) => category.id === categoryId,
          );
          return category ? category.name : null;
        })
        .filter((name) => name !== null);
    } else {
      selectedCategoryNames = categories.map((category) => category.name);
    }

    props.onSelectFieldsChange(selectedCategoryNames);
  };

  const emailRegex = Validation.emailRegex;

  const modifyValue = (type, value) => {
    if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);
    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);

    setCustomErrors(errors);
  };

  function capitalizeWords(str) {
    if (!str) return "";

    return str
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .map((word) => word[0].toUpperCase() + word.slice(1))
      .join(" ");
  }

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name !== "account_name") {
      value = modifyValue(name, value?.replace(/\s/g, ""));
    } else {
      value = value.replace(/\s+/g, " ");
    }

    if (props.payload) {
      if (allowedValue(name, value)) {
        validateAndRecordError(name, value);
        const newObj = { ...props.payload, [name]: value };
        props?.setPayload(newObj);
      }
      if (
        props?.payload?.contact_no &&
        (props?.payload?.contact_no?.length ===
          GlobalConfiguration.lengthCheckZero ||
          props?.payload?.contact_no?.length < GlobalConfiguration.panLength)
      ) {
        setContactNumberValidation(false);
      }
      if (
        props?.payload?.email_id &&
        props?.payload?.email_id?.length === GlobalConfiguration.lengthCheckZero
      ) {
        setEmailValidation(false);
      }
      if (name === "account_name") {
        if (value.trim().length > GlobalConfiguration.lengthCheckZero) {
          if (value === capitalizeWords(verifyPAN?.pan_details?.full_name)) {
            props?.setSelectedValue("legalname");
          } else if (value === capitalizeWords(props.payload.userName)) {
            props?.setSelectedValue("username");
          } else {
            props?.setSelectedValue("customname");
          }
          props?.setAccountNameValidation(true);
        }
      }
    }
  };

  useMemo(() => {
    if (customErrors["contact_no"]) {
      setContactNumberValidation(false);
    }
    if (
      !customErrors["contact_no"] &&
      props.payload.contact_no?.length === GlobalConfiguration.panLength
    ) {
      setContactNumberValidation(true);
    }
    if (customErrors["email_id"]) {
      setEmailValidation(false);
    }
    if (
      !customErrors["email_id"] &&
      props.payload.email_id?.length > GlobalConfiguration.lengthCheckZero &&
      emailRegex.test(props.payload.email_id)
    ) {
      setEmailValidation(true);
    }
  }, [contactNumberValidation, emailValidation, customErrors, props.payload]);

  useEffect(() => {
    if (
      emailValidation &&
      contactNumberValidation &&
      props?.accountNameValidation
    ) {
      props.BenEnableNextButton(false);
      props.parentCreateBen({
        email: emailValidation,
        contact: contactNumberValidation,
        accountname: props?.accountNameValidation,
      });
    } else if (props?.activeStep === GlobalConfiguration.lengthCheckTwo) {
      props.parentCreateBen({
        email: emailValidation,
        contact: contactNumberValidation,
        accountname: props?.accountNameValidation,
      });
      props.BenEnableNextButton(true);
    }
    handleCategorySelect(props?.selectedCatFields);
  }, [
    props?.selectedCatFields,
    isAllSelected,
    emailValidation,
    contactNumberValidation,
    props?.accountNameValidation,
    props?.activeStep,
  ]);

  const handleDivBtn = (value) => {
    props?.setSelectedValue(value);
    if (value === "legalname") {
      handleUpdateLegalName();
    } else if (value === "username") {
      handleUpdateUsername();
    }
  };

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("AvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, []);

  useEffect(() => {
    if (labelpopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [labelpopup]);

  return (
    <>
      <div className="px-padding-md lg:px-padding-base pb-padding-md py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <AccountName
            handleChange={handleChange}
            accountNameValidation={props?.accountNameValidation}
            accountName={props.payload.account_name}
            selectedValue={props?.selectedValue}
            handleDivBtn={handleDivBtn}
            handleRadioBtn={handleRadioBtn}
            selectedRadioValue={props?.selectedValue}
            legalName={props?.payload?.legalName}
            type={"user"}
            userName={props.payload.userName}
            setSelectedValue={props?.setSelectedValue}
          />

          <LinkEntityCard
            payload={props?.payload}
            setPayload={props?.setPayload}
            selectedValue={props?.selectedValue}
            headerTitle="User view all"
            redirectPath="/settings/user_view_all"
            flow="fieldforceaccountcreate"
            title="User"
            description="Linked user will be able to create field force requests."
            buttonText="Select user to link"
          />

          <ContactDetails
            handleChange={handleChange}
            contactNumberValidation={contactNumberValidation}
            emailValidation={emailValidation}
            contactNumber={props.payload.contact_no}
            emailId={props.payload.email_id}
            selectedValue={props?.selectedValue}
          />
        </CommonLayout>
      </div>
    </>
  );
};

export default FieldForceContactDetails;
